module.exports = __webpack_public_path__ + "img/logo_blue.f1ea14ae.png";